import {makeAutoObservable} from "mobx";
import {displayErrorDialogPrompt} from "../common/util/errror/log.util";
import {getDayPath, getDefaultContentUrl} from "./ContentStore";
import {TranslationLangTypes} from "../common/enums/ContentEnum";

const logPrefix  = "[OddStepThreeStore]"
export default class OddStepThreeStore {
    constructor(props) {
        this.contentRepository = props.contentRepository;
        this.contentStore = props.contentStore;
        this.dialogStore = props.dialogStore;
        this.commonStore = props.commonStore;

        this.contentTapIndex = 0;
        this.mainList = [];
        this.translationList = [];
        this.originalTranslationList = [];

        makeAutoObservable(this);
    }

    openErrorDialog = (info) => {
        if (this?.dialogStore) {
            this.dialogStore.openErrorDialog(info)
        }
    }

    getMainText = (languageCode) => {
        const main = this.mainList.find((mt) => mt.languageCode === languageCode);

        return main.text;
    }

    getSortedTranslationListByLangCode = (translationList) => {
        let sortedTranslationList = [];
        for (const langType of TranslationLangTypes) {
            const translation = translationList.find((tt) => tt.languageCode === langType);
            if (translation) {
                sortedTranslationList.push(translation);
            }
        }
        return sortedTranslationList;
    }

    getTranslation = (languageCode) => {
        return this.translationList.find((t) => t.languageCode === languageCode);
    }

    setTranslationText = (text, languageCode) => {
        const translation = this.getTranslation(languageCode);
        translation.text = text;
    }

    changeTranslationText = (languageCode, text) => {
        const translation = this.getTranslation(languageCode);
        if (translation) {
            translation.text = text;
        }
    }

    changeTranslationEnable = (languageCode) => {
        const translation = this.getTranslation(languageCode);
        if (translation) {
            translation.enable = !translation.enable;
        }
    }

    isChangeTranslation = () => {
        if (this.originalTranslationList.length !== this.translationList.length) {
            return true;
        }

        for (let i = 0; i < this.originalTranslationList.length; i++) {
            const originalTranslation = this.originalTranslationList[i];
            const translation = this.translationList[i];

            const originalTranslationKey = Object.keys(originalTranslation);
            const translationKey = Object.keys(translation);

            if (originalTranslationKey.length !== translationKey.length) {
                return true;
            }

            for (const key of originalTranslationKey) {
                if (originalTranslation[key] !== translation[key]) {
                    return true;
                }
            }
        }

        return false;
    }

    isChangeTranslationText = (languageCode) => {
        const translation = this.getTranslation(languageCode);
        const originalTranslation= this.originalTranslationList.find((tt) => tt.languageCode === languageCode);
        return translation.text !== originalTranslation.text;
    }

    * getOddStepThreeContent(step, day, callback) {
        this.commonStore.setLoadingState();
        try {
            console.log(logPrefix, 'Start getOddStepThreeContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/3`;
            const response = yield this.contentRepository.getContent(url);

            this.mainList = response.data.mains;

            this.translationList = this.getSortedTranslationListByLangCode(response.data.translations);
            this.originalTranslationList = JSON.parse(JSON.stringify(this.translationList));

            console.log(logPrefix, 'Finished getOddStepThreeContent.');
            callback && callback(response.data);
        } catch (e) {
            console.log(logPrefix, 'Failed getOddStepThreeContent.');
            this.openErrorDialog({
                titleText: '컨텐츠 불러오기 오류',
                text: displayErrorDialogPrompt(e, '컨텐츠를 불러오는 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * modifyOddStepThreeContent(step, day, callback) {
        this.commonStore.setLoadingState('데이터를 저장하는 중입니다.');
        try {
            console.log(logPrefix, 'Start modifyOddStepThreeContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/3`;
            const response = yield this.contentRepository.putContent(url, this.translationList);
            console.log(logPrefix, 'Finished modifyOddStepThreeContent : ', response);
            callback && callback();
        } catch (e) {
            this.commonStore.initLoadingState();
            console.log(logPrefix, 'Failed modifyOddStepThreeContent.');
            this.openErrorDialog({
                titleText: '컨텐츠 수정 오류',
                text: displayErrorDialogPrompt(e, '컨텐츠 수정 작업중 에러가 발생했습니다.')
            });
        }
    }

    isOddStepThreeCompleted = (data) => {
        for (const translation of data.translations) {
            if (translation.enable && (translation.text === '')) {
                return false;
            }
        }
        return true;
    }
}
